import { render } from "./sales-returns.vue?vue&type=template&id=800e708a&scoped=true"
import script from "./sales-returns.vue?vue&type=script&lang=js"
export * from "./sales-returns.vue?vue&type=script&lang=js"

import "./sales-returns.vue?vue&type=style&index=0&id=800e708a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800e708a"]])

export default __exports__